import { IPCC } from '@/app/org-cfv/src/enums/CreateProjectEnum';
import { RefrigerantGHG } from '@/app/org-cfv/src/enums/FugitiveEmissionEnum';
import { ResponseSuccess } from '@/typings/api';

export enum MAKGEOLLI_FACTORS_GREENHOUSE_GASES_API_KEY {
  GET = 'GET/MAKGEOLLI_FACTORS_GREENHOUSE_GASES',
  // [PLOP ANCHOR] apisKeyEnum
}

export interface GetMakgeolliFactorsGreenhouseGasesParams {
  query: {
    arVersion: IPCC;
    search?: string;
  };
}

export const initGasComposition: GasComposition = {
  chemicalFormulaName: '',
  shortName: '',
  isMontrealRegulated: false,
  isIncluded: true,
};

export const REFRIGERANT_COMPOSITION_LIMIT = 5;

export const defaultCustomRefrigerant: RefrigerantGhgs = {
  key: RefrigerantGHG.GHG_CUSTOM_1,
  chemicalFormulaName: '',
  shortName: '',
  isMontrealRegulated: false,
  gwp: undefined,
  gasComposition: [initGasComposition],
};

export interface GasComposition {
  chemicalFormulaName: string;
  shortName: string;
  isMontrealRegulated?: boolean;
  ratio?: number;
  isIncluded?: boolean;
}

export interface RefrigerantGhgs {
  key: RefrigerantGHG;
  chemicalFormulaName: string;
  shortName: string;
  isMontrealRegulated: boolean;

  //if undefined means no gwp in this ipcc setting
  gwp?: number;

  //if undefined means no gwp in this ipcc setting
  gasComposition?: GasComposition[];
}

export interface RefrigerantComposition {
  refrigerant: RefrigerantGHG;
  chemicalFormulaName: string;
  shortName: string;
  isMontrealRegulated: boolean;

  //if undefined means no gwp in this ipcc setting
  gwp?: number;

  //if undefined means no gwp in this ipcc setting
  gasComposition?: GasComposition[];
}
export interface GetMakgeolliFactorsGreenhouseGasesResData {
  ghgs: RefrigerantGhgs[];
}
export type GetMakgeolliFactorsGreenhouseGasesRes = ResponseSuccess<GetMakgeolliFactorsGreenhouseGasesResData>;

// [PLOP ANCHOR] dtoDefinition
